import { Component, h } from 'preact'
import CategorySelect from './CategorySelect'
import ArticlePreviewSettings from '../create-topic-page/PreviewSettings'
import Checkbox from '../ui-components/Checkbox'
import Attachments from '../category/control/Attachments'
import { DropdownSelectizeInput } from '../dropdown/DropdownSelectize'
import { ParentCategory } from '../category-selector/CategorySelector'
import PublicTagSelect from '../public-tag/PublicTagSelect'

interface Props {
  error: string,
  forum_id: number | null,
  categories: ParentCategory[],
  allowReplies: boolean,
  sticky: boolean,
  featuredImage: string | null,
  tags: string[],
  onUpdate: (field: string, value: any) => void,
  isKnowledgeBaseEnabled: boolean,
  isGroupsEnabled: boolean,
  isPublicTagManagementEnabled: boolean,
  articleId?: number | null,
  isPreviewPublic: boolean | null,
  onShowArticlePreviewModal: () => void,
  onError: () => void,
  onSuccess: (message: string) => void,
  labels: string[],
  public_label: string | null,
  canEndUserAddPublicTags: boolean
}

export default class Sidebar extends Component<Props> {
  render (props: Props) {
    const {
      error,
      forum_id,
      categories,
      allowReplies,
      sticky,
      featuredImage,
      tags,
      onUpdate,
      isKnowledgeBaseEnabled,
      isGroupsEnabled,
      articleId,
      isPreviewPublic,
      onShowArticlePreviewModal,
      onError,
      onSuccess,
      labels,
      public_label,
      isPublicTagManagementEnabled,
      canEndUserAddPublicTags
    } = props

    return (
      <div class='article-creator__sidebar topic-creator__sidebar category-add_container'>
        {articleId && <a
          href={`/article/${articleId}/versions`}
          class='article-creator__sidebar-versions topic-creator__sidebar-versions'>Version History</a>
        }
        {articleId && <ArticlePreviewSettings
          type='article'
          generatePreviewLink='/draft/generatePreviewLink'
          topicId={articleId}
          isPublic={isPreviewPublic || false}
          onShowPreviewModal={onShowArticlePreviewModal}
          onError={onError}
          onSuccess={onSuccess} />
        }
        <CategorySelect
          forum_id={forum_id}
          categories={categories}
          isKnowledgeBaseEnabled={isKnowledgeBaseEnabled}
          isGroupsEnabled={isGroupsEnabled}
          error={error}
          onUpdate={forumId => onUpdate('forum_id', forumId)}
        />
        {error && <span class='error'>{error}</span>}
        <div class='form-group'>
          <Checkbox
            label='Allow replies'
            onUpdate={status => onUpdate('open', status)}
            qaClasses='qa-open'
            checked={allowReplies}
          />
          <Checkbox
            label='Sticky topic'
            onUpdate={status => onUpdate('sticky', status)}
            qaClasses='qa-sticky'
            checked={sticky}
          />
        </div>
        <div class='form-group'>
          <label for='article-label'>Article Label</label>
          <DropdownSelectizeInput
            single
            items={labels}
            class='js-public-label js-field form-control selectize-allow-input qa-public-label'
            placeholder='Add a label next to article title'
            selectedItem={public_label || this.props.public_label || ''}
            onChange={(label: string) => onUpdate('public_label', label)}
          />
        </div>
        <Attachments
          label='Featured Image'
          className='article-creator__sidebar-featured-image'
          meta={<div>Maximum file size: 5M. Allowed image types: .jpg, .jpeg, .png, .gif. We recommend a minimum of 1440*640px</div>}
          isAttachmentSelected={featuredImage !== ''}
          imageSrc={featuredImage || null}
          width={1440}
          height={640}
          onUpdate={(data: undefined | {source_thumb: string}) => onUpdate('featured_image', data ? data.source_thumb : null)}
        />
        <div>
          <label for='public-tags-label'>Public Tags</label>
          { isPublicTagManagementEnabled
            ? <PublicTagSelect
              isEdit={false}
              onChange={(tags) => onUpdate('tags', tags)}
              selectedPublicTags={tags.join(',')}
              inputName='form-control qa-article-creator-public-tags-input'
              canEndUserAddPublicTags={canEndUserAddPublicTags}
              iconSize={12} />
            : <DropdownSelectizeInput
              items={[]}
              single={false}
              class='form-control qa-article-creator-public-tags-input'
              placeholder='Add tags to help readers easily find this article'
              selectedItems={tags && tags.length ? tags : (tags || [])}
              onChange={(tags) => onUpdate('tags', tags)} />
          }
        </div>
      </div>
    )
  }
}
